import { string } from 'prop-types'
import { pipe, replace, __ } from 'ramda'
import { Typography } from '@telus-uds/components-web'

/**
 * This component formats any 🅫 and 🅪 trademark symbols in our locales
 * and replaces them to become text and sets innerHTML styles.
 * Note: this component can be removed if these symbols are available sans serif
 * @param {string} text String with or without trademark symbol
 * @returns Formatted text with trademark symbol wrapped in a UDS Typography component
 */
const FormattedTrademarkTextWrapper = ({ text }) => {
  if (!text) return null

  const replaceMD = replace(
    '🅫',
    '<sup data-testid="formatted-trademark" style="font-weight:500; font-size:.6rem">MD</sup>',
    __
  )
  const replaceMC = replace(
    '🅪',
    '<sup data-testid="formatted-trademark" style="font-weight:500; font-size:.6rem">MC</sup>',
    __
  )
  const replaceSymbols = pipe(replaceMC, replaceMD)

  const formattedText = (
    <Typography variant={{ size: 'medium' }} testID="name-field-text">
      <span
        dangerouslySetInnerHTML={{
          __html: replaceSymbols(text)
        }}
      />
    </Typography>
  )

  return formattedText
}

export default FormattedTrademarkTextWrapper

FormattedTrademarkTextWrapper.propTypes = {
  text: string.isRequired
}
